export default __webpack_public_path__ + "static/media/loginImage.8e80208c.svg";